import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function TrustBadge() {
  const [score, setScore] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/best-practices/audit`)
      .then((r) => r.json())
      .then((d) => setScore(d?.score_pct ?? null))
      .catch(() => {});
  }, []);

  if (score === null) return null;

  return (
    <Link
      to="/trust"
      data-testid="trust-badge"
      title="Live platform audit"
      className="hidden sm:inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold transition hover:brightness-125
        bg-gradient-to-r from-emerald-500/15 to-cyan-500/15 border border-emerald-500/30 text-emerald-300"
    >
      <ShieldCheck className="w-3 h-3" />
      Platform {score}%
    </Link>
  );
}
